import { render } from "./OrderFile.vue?vue&type=template&id=47a9e4d5&ts=true"
import script from "./OrderFile.vue?vue&type=script&lang=ts"
export * from "./OrderFile.vue?vue&type=script&lang=ts"

import "./OrderFile.vue?vue&type=style&index=0&id=47a9e4d5&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__